export const Profile = () => import("./Profile.vue");
export const Activity = () => import("./Activity.vue");
export const ChangePassword = () => import("./ChangePassword.vue");
export const AppointChange = () => import("./AppointChange.vue");
